/* JOLI POT, compléments des articles de blog (assets/jp-article-plus.js), 22/10/2026
   Chargé par snippets/jp-article-plus.liquid (rendu sur les pages article via snippets/jp-article-schema.liquid),
   après assets/jp-carte-apercu.js. Ne modifie pas le contenu des articles.
   1. Aperçus de cartes à planter (liste jp-cartes) : le dessin construit par sections/jp-article.liquid est remplacé
      par le moteur partagé JPCarte (assets/jp-carte-apercu.js), le même que le configurateur et la fiche carte à planter :
      papier ensemencé, texte ajusté automatiquement, petit cœur, logo Joli Pot en bas. Loupe et lien « écrire ce texte » conservés.
   2. Sommaire « Dans cet article » : titre complet en infobulle, et sur ordinateur la liste défile à l'intérieur
      pour que la colonne collante ne dépasse pas la hauteur de l'écran (la carte « Personnaliser » reste visible). */
(function () {
  var zoom = null;

  function cartes(racine) {
    var C = window.JPCarte;
    if (!C) return;
    var style = C.STYLES[0];
    racine.querySelectorAll('.jpa .jp-mcarte__papier:not(.jpca-ok)').forEach(function (pa) {
      var tx = pa.querySelector('.jp-mcarte__txt');
      var t = tx ? tx.textContent.trim() : '';
      if (!t) return;
      pa.classList.add('jpca-ok');
      pa.innerHTML = '';
      var ap = C.creer();
      pa.appendChild(ap.el);
      ap.maj({ texte: t, style: style });
      /* Loupe : la fenêtre s'ouvre (assets/jp-pot-apercu.js), puis on y pose une carte dessinée par le même moteur */
      var li = pa.closest('li');
      var btn = li ? li.querySelector('.jpz-btn') : null;
      if (btn) btn.addEventListener('click', function () {
        var hote = pa.closest('[data-perso]') || document;
        var vue = hote.querySelector('dialog.jpz .jpz__vue');
        if (!vue) return;
        if (!zoom) zoom = C.creer();
        vue.innerHTML = '';
        vue.appendChild(zoom.el);
        zoom.maj({ texte: t, style: style });
      });
    });
    if (window.JPPOT && window.JPPOT.replacer) window.JPPOT.replacer();
  }

  function sommaire(racine) {
    racine.querySelectorAll('.jpa__sommaire').forEach(function (s) {
      s.querySelectorAll('ol a').forEach(function (a) {
        var t = a.textContent.replace(/\s+/g, ' ').trim();
        if (t && !a.title) a.title = t;
      });
      var ol = s.querySelector('ol');
      if (!ol) return;
      var mq = window.matchMedia('(min-width: 1100px)');
      function hauteur() {
        if (!mq.matches) { ol.style.maxHeight = ''; return; }
        ol.style.maxHeight = 'none';
        if (!ol.offsetHeight) return;
        var haut = parseFloat(window.getComputedStyle(s).top) || 120;
        var dispo = window.innerHeight - haut - 16;
        var reste = s.offsetHeight - ol.offsetHeight;
        ol.style.maxHeight = Math.max(96, Math.floor(dispo - reste)) + 'px';
      }
      hauteur();
      window.addEventListener('resize', hauteur);
      var d = s.querySelector('details');
      if (d) d.addEventListener('toggle', hauteur);
      var img = s.querySelector('.jpa__cote img');
      if (img && !img.complete) img.addEventListener('load', hauteur);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(hauteur);
    });
  }

  function lancer(racine) { cartes(racine); sommaire(racine); }
  document.addEventListener('DOMContentLoaded', function () { lancer(document); });
  document.addEventListener('shopify:section:load', function (e) { if (e.target) setTimeout(function () { lancer(e.target); }, 0); });
})();
